import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/SponsoredPostsCount.graphql';
import { Query, QuerysponsoredPostsCountArgs } from '../../__generated__/globalTypes';

export const useSponsoredPostsCountQuery = (options?: QueryHookOptions<Query, QuerysponsoredPostsCountArgs>) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QuerysponsoredPostsCountArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useSponsoredPostsCountLazyQuery = (
  options?: LazyQueryHookOptions<Query, QuerysponsoredPostsCountArgs>
): QueryResult<Query, QuerysponsoredPostsCountArgs> & {
  getSponsoredPostsCount: LazyQueryExecFunction<Query, QuerysponsoredPostsCountArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getSponsoredPostsCount, result] = useLazyQuery<Query, QuerysponsoredPostsCountArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getSponsoredPostsCount, ...result };
};

export const useSponsoredPostsCountPromiseQuery = () => {
  const client = useApolloClient();

  const getSponsoredPostsCount = useCallback(
    (options?: Omit<QueryOptions<QuerysponsoredPostsCountArgs, Query>, 'query'>) =>
      client.query<Query, QuerysponsoredPostsCountArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getSponsoredPostsCount };
};
// Suspense Query Hooks
export const useSponsoredPostsCountSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QuerysponsoredPostsCountArgs>
) => {
  const result = useSuspenseQuery<Query, QuerysponsoredPostsCountArgs>(QUERY, {
    ...options
  });

  return result;
};
